<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col md="6" sm="12">
        <v-card outlined>
          <form @submit.prevent="save">
            <v-container fluid>
              <v-card-text>
                You must renter your password to continue.
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="form.password"
                  label="Password"
                  outlined
                  :class="{ 'is-invalid': form.errors.password }"
                  class="form-control"
                  name="password"
                  :error="form.errors.password === true"
                  :error-messages="form.errors.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  depressed
                  :loading="loading"
                  color="primary"
                  type="submit"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-container>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo: { title: 'Reauthenticate' },
   layout: (h, page) => h(Layout, [page]),

   props: {
      //
   },

   data () {
      return {
         loading: false,
         showPassword: false,
         form: {
            password: null,
         },
      }
   },
   methods: {
      save () {
         this.loading = true
         this.$inertia.post(this.route('auth.reauthenticate'), this.form).then(() => this.loading = false)
      },
   },
}
</script>
